module.exports = __webpack_public_path__ + "assets/51e8b03e6050de1fba605ba8692501a6.jpg";